export default __webpack_public_path__ + "static/690-6f130d2c8aaed2e9ccefa5fa00c60a4e.gif";